module.exports = __webpack_public_path__ + "img/4.396cd276.png";